import { createFileRoute, Outlet } from '@tanstack/react-router';
import { ProtectedRoute } from '@/components/auth/protected-route';
import { Permissions } from '@/constants/roles-permissions';

export const Route = createFileRoute('/_authenticated/user-sessions')({
  component: UserSessionsLayout,
});

function UserSessionsLayout() {
  return (
    <ProtectedRoute requiredPermission={Permissions.UserActivityView}>
      <Outlet />
    </ProtectedRoute>
  );
}
